import apiClient, { toApiError } from "@/services/api/client";
import { ApiResponse } from "@/types/api.types";
import { Notification } from "@/types/notification.types";

export const notificationsApi = {
  // Get all alerts/notifications (backend terminology usually alerts)
  getNotifications: async (params?: {
    page?: number;
    unreadOnly?: boolean;
    symbol?: string;
  }): Promise<{ alerts: Notification[]; total: number; page: number }> => {
    try {
      const response = await apiClient.get<
        ApiResponse<{ alerts: Notification[]; total: number; page: number }>
      >("/alerts", {
        params,
      });
      return response.data.data;
    } catch (error) {
      throw toApiError(error);
    }
  },

  // Get unread count
  getUnreadCount: async (): Promise<number> => {
    try {
      const response = await apiClient.get<ApiResponse<{ count: number }>>(
        "/alerts/unread/count",
      );
      return response.data.data.count;
    } catch (error) {
      throw toApiError(error);
    }
  },

  // Mark single notification as read
  markAsRead: async (id: number | string): Promise<void> => {
    try {
      await apiClient.put(`/alerts/${id}/read`);
    } catch (error) {
      throw toApiError(error);
    }
  },

  // Mark all as read
  markAllAsRead: async (): Promise<void> => {
    try {
      await apiClient.put("/alerts/read/all");
    } catch (error) {
      throw toApiError(error);
    }
  },
};
